import { render, staticRenderFns } from "./ToBeAssigned.vue?vue&type=template&id=1747c806&scoped=true&"
import script from "./ToBeAssigned.vue?vue&type=script&lang=js&"
export * from "./ToBeAssigned.vue?vue&type=script&lang=js&"
import style0 from "./ToBeAssigned.vue?vue&type=style&index=0&id=1747c806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747c806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VNavigationDrawer,VPagination,VTextField,VTooltip})
